export default __webpack_public_path__ + "static/media/whyPatersonBanner.0aa89d16.png";